/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      name
      active
      trial
      usernames
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $id: ID
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCustomers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        active
        trial
        usernames
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAssessment = /* GraphQL */ `
  query GetAssessment($id: ID!) {
    getAssessment(id: $id) {
      id
      name
      description
      contactPerson
      type
      imageKey
      active
      public
      language
      ownerGroups
      assessmentAssignments {
        nextToken
        __typename
      }
      modules {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAssessments = /* GraphQL */ `
  query ListAssessments(
    $id: ID
    $filter: ModelAssessmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAssessments(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        contactPerson
        type
        imageKey
        active
        public
        language
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAssessmentAssignment = /* GraphQL */ `
  query GetAssessmentAssignment($id: ID!) {
    getAssessmentAssignment(id: $id) {
      id
      customerID
      assessmentID
      performAssessments {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      version
      package
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAssessmentAssignments = /* GraphQL */ `
  query ListAssessmentAssignments(
    $id: ID
    $filter: ModelAssessmentAssignmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAssessmentAssignments(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        customerID
        assessmentID
        version
        package
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const assessmentAssignmentsByCustomerID = /* GraphQL */ `
  query AssessmentAssignmentsByCustomerID(
    $customerID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAssessmentAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assessmentAssignmentsByCustomerID(
      customerID: $customerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        assessmentID
        version
        package
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const assessmentAssignmentsByAssessmentID = /* GraphQL */ `
  query AssessmentAssignmentsByAssessmentID(
    $assessmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAssessmentAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assessmentAssignmentsByAssessmentID(
      assessmentID: $assessmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        assessmentID
        version
        package
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getModule = /* GraphQL */ `
  query GetModule($id: ID!) {
    getModule(id: $id) {
      id
      sortingNumber
      title
      assessmentID
      ownerGroups
      questions {
        nextToken
        __typename
      }
      structuredEntries {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listModules = /* GraphQL */ `
  query ListModules(
    $id: ID
    $filter: ModelModuleFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listModules(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sortingNumber
        title
        assessmentID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const modulesByAssessmentID = /* GraphQL */ `
  query ModulesByAssessmentID(
    $assessmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelModuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    modulesByAssessmentID(
      assessmentID: $assessmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sortingNumber
        title
        assessmentID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestion = /* GraphQL */ `
  query GetQuestion($id: ID!) {
    getQuestion(id: $id) {
      id
      title
      package
      text
      source
      moduleID
      ownerGroups
      requirements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuestions = /* GraphQL */ `
  query ListQuestions(
    $id: ID
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listQuestions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        package
        text
        source
        moduleID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const questionsByModuleID = /* GraphQL */ `
  query QuestionsByModuleID(
    $moduleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    questionsByModuleID(
      moduleID: $moduleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        package
        text
        source
        moduleID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRequirement = /* GraphQL */ `
  query GetRequirement($id: ID!) {
    getRequirement(id: $id) {
      id
      questionID
      text
      weight
      gradations
      ownerGroups
      recommendations {
        nextToken
        __typename
      }
      requirementAnswers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRequirements = /* GraphQL */ `
  query ListRequirements(
    $id: ID
    $filter: ModelRequirementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRequirements(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        questionID
        text
        weight
        gradations
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requirementsByQuestionID = /* GraphQL */ `
  query RequirementsByQuestionID(
    $questionID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requirementsByQuestionID(
      questionID: $questionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        questionID
        text
        weight
        gradations
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecommendation = /* GraphQL */ `
  query GetRecommendation($id: ID!) {
    getRecommendation(id: $id) {
      id
      requirementID
      level
      description
      recommendationText
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecommendations = /* GraphQL */ `
  query ListRecommendations(
    $id: ID
    $filter: ModelRecommendationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRecommendations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        requirementID
        level
        description
        recommendationText
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const recommendationsByRequirementID = /* GraphQL */ `
  query RecommendationsByRequirementID(
    $requirementID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecommendationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recommendationsByRequirementID(
      requirementID: $requirementID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requirementID
        level
        description
        recommendationText
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStructuredEntry = /* GraphQL */ `
  query GetStructuredEntry($id: ID!) {
    getStructuredEntry(id: $id) {
      id
      title
      description
      source
      entries {
        impact
        risk
        opportunity
        example
        __typename
      }
      threshold
      moduleID
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStructuredEntries = /* GraphQL */ `
  query ListStructuredEntries(
    $id: ID
    $filter: ModelStructuredEntryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStructuredEntries(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        description
        source
        threshold
        moduleID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const structuredEntriesByModuleID = /* GraphQL */ `
  query StructuredEntriesByModuleID(
    $moduleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStructuredEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    structuredEntriesByModuleID(
      moduleID: $moduleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        source
        threshold
        moduleID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPerformAssessment = /* GraphQL */ `
  query GetPerformAssessment($id: ID!) {
    getPerformAssessment(id: $id) {
      id
      assessmentState
      assessmentAssignmentID
      requirementAnswers {
        nextToken
        __typename
      }
      evaluations {
        nextToken
        __typename
      }
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPerformAssessments = /* GraphQL */ `
  query ListPerformAssessments(
    $filter: ModelPerformAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPerformAssessments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assessmentState
        assessmentAssignmentID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const performAssessmentsByAssessmentAssignmentID = /* GraphQL */ `
  query PerformAssessmentsByAssessmentAssignmentID(
    $assessmentAssignmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPerformAssessmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    performAssessmentsByAssessmentAssignmentID(
      assessmentAssignmentID: $assessmentAssignmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assessmentState
        assessmentAssignmentID
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRequirementAnswer = /* GraphQL */ `
  query GetRequirementAnswer($id: ID!) {
    getRequirementAnswer(id: $id) {
      id
      requirementID
      performedAssessmentID
      selectedLevel
      fulfilled
      irrelevant
      comment
      contactPerson
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRequirementAnswers = /* GraphQL */ `
  query ListRequirementAnswers(
    $id: ID
    $filter: ModelRequirementAnswerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRequirementAnswers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        requirementID
        performedAssessmentID
        selectedLevel
        fulfilled
        irrelevant
        comment
        contactPerson
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requirementAnswersByRequirementID = /* GraphQL */ `
  query RequirementAnswersByRequirementID(
    $requirementID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequirementAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requirementAnswersByRequirementID(
      requirementID: $requirementID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requirementID
        performedAssessmentID
        selectedLevel
        fulfilled
        irrelevant
        comment
        contactPerson
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const requirementAnswersByPerformedAssessmentID = /* GraphQL */ `
  query RequirementAnswersByPerformedAssessmentID(
    $performedAssessmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRequirementAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requirementAnswersByPerformedAssessmentID(
      performedAssessmentID: $performedAssessmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requirementID
        performedAssessmentID
        selectedLevel
        fulfilled
        irrelevant
        comment
        contactPerson
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvaluation = /* GraphQL */ `
  query GetEvaluation($id: ID!) {
    getEvaluation(id: $id) {
      id
      introText
      performedAssessmentID
      assessmentAssignmentID
      evaluationModuleData {
        nextToken
        __typename
      }
      state
      language
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEvaluations = /* GraphQL */ `
  query ListEvaluations(
    $filter: ModelEvaluationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvaluations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        introText
        performedAssessmentID
        assessmentAssignmentID
        state
        language
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const evaluationsByPerformedAssessmentID = /* GraphQL */ `
  query EvaluationsByPerformedAssessmentID(
    $performedAssessmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEvaluationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    evaluationsByPerformedAssessmentID(
      performedAssessmentID: $performedAssessmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        introText
        performedAssessmentID
        assessmentAssignmentID
        state
        language
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const evaluationsByAssessmentAssignmentID = /* GraphQL */ `
  query EvaluationsByAssessmentAssignmentID(
    $assessmentAssignmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEvaluationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    evaluationsByAssessmentAssignmentID(
      assessmentAssignmentID: $assessmentAssignmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        introText
        performedAssessmentID
        assessmentAssignmentID
        state
        language
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvaluationModuleData = /* GraphQL */ `
  query GetEvaluationModuleData($id: ID!) {
    getEvaluationModuleData(id: $id) {
      id
      relatedEvaluationId
      moduleID
      resultText
      rating
      maxRating
      questionRating {
        questionID
        rating
        maxRating
        hasAnswer
        __typename
      }
      completelyAnswered
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEvaluationModuleData = /* GraphQL */ `
  query ListEvaluationModuleData(
    $filter: ModelEvaluationModuleDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvaluationModuleData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        relatedEvaluationId
        moduleID
        resultText
        rating
        maxRating
        completelyAnswered
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const evaluationModuleDataByRelatedEvaluationId = /* GraphQL */ `
  query EvaluationModuleDataByRelatedEvaluationId(
    $relatedEvaluationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEvaluationModuleDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    evaluationModuleDataByRelatedEvaluationId(
      relatedEvaluationId: $relatedEvaluationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        relatedEvaluationId
        moduleID
        resultText
        rating
        maxRating
        completelyAnswered
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPublicAssessmentSubmission = /* GraphQL */ `
  query GetPublicAssessmentSubmission($id: ID!) {
    getPublicAssessmentSubmission(id: $id) {
      id
      assessmentID
      customerName
      customerMail
      customerPhone
      customerOrganization
      consentMarketingMails
      preferences
      answerData
      evaluationData
      ownerGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPublicAssessmentSubmissions = /* GraphQL */ `
  query ListPublicAssessmentSubmissions(
    $id: ID
    $filter: ModelPublicAssessmentSubmissionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPublicAssessmentSubmissions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        assessmentID
        customerName
        customerMail
        customerPhone
        customerOrganization
        consentMarketingMails
        preferences
        answerData
        evaluationData
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const publicAssessmentSubmissionsByAssessmentID = /* GraphQL */ `
  query PublicAssessmentSubmissionsByAssessmentID(
    $assessmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPublicAssessmentSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicAssessmentSubmissionsByAssessmentID(
      assessmentID: $assessmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        assessmentID
        customerName
        customerMail
        customerPhone
        customerOrganization
        consentMarketingMails
        preferences
        answerData
        evaluationData
        ownerGroups
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
